import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  categoryName: string;
  categorySlug: string;
  publishDate: string;
  views: number;
  variant?: 'default' | 'horizontal' | 'compact';
  className?: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  categoryName,
  categorySlug,
  publishDate,
  views,
  variant = 'default',
  className = '',
}: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link to={`/article/${slug}`} className={`group flex gap-3 cursor-pointer ${className}`}>
        <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
          <img src={image} alt={title} title={`${title} - 17吃瓜网`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">{title}</h3>
          <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
            <span>{publishDate}</span>
            <span>·</span>
            <span>{views.toLocaleString()} 阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'horizontal') {
    return (
      <Link to={`/article/${slug}`} className={`group flex flex-col sm:flex-row gap-4 cursor-pointer ${className}`}>
        <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
          <img src={image} alt={title} title={`${title} - 17吃瓜网`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
        </div>
        <div className="flex-1 min-w-0 flex flex-col justify-center">
          <Link to={`/category/${categorySlug}`} className="inline-block w-fit">
            <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{categoryName}</span>
          </Link>
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mt-2 leading-snug">{title}</h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mt-1.5 leading-relaxed">{excerpt}</p>
          <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
            <span>{publishDate}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {views.toLocaleString()}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/article/${slug}`} className={`group flex flex-col cursor-pointer ${className}`}>
      <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
        <img src={image} alt={title} title={`${title} - 17吃瓜网`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
      </div>
      <div className="mt-3">
        <Link to={`/category/${categorySlug}`} className="inline-block w-fit">
          <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{categoryName}</span>
        </Link>
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mt-2 leading-snug">{title}</h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mt-1.5 leading-relaxed">{excerpt}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span>{publishDate}</span>
          <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {views.toLocaleString()}</span>
        </div>
      </div>
    </Link>
  );
}